'use strict';

import angular from 'angular';
import ShowController from './show.controller';

export default angular.module('updateServerApp.apps.show', [])
  .controller('AppsShowController', ShowController)
  .name;



// WEBPACK FOOTER //
// ./client/app/apps/show/index.js